import { sample } from 'effector'
import { createGate, useGate, useUnit } from 'effector-react'
import dynamic from 'next/dynamic'

import * as chat from '@/entities/chat'
import { $portalProfile } from '@/entities/profile/portal'
import { isNotNull } from '@/shared/lib/types'

import * as chatModel from '../model'
import * as styled from './styled'

const ChatView = dynamic(() => import('./chat').then((module) => module.ChatView), {
    loading: () => <styled.ChatLoader />,
})

const Gate = createGate()

sample({
    clock: sample({
        clock: [$portalProfile, Gate.open],
        source: $portalProfile,
        filter: isNotNull,
    }),
    filter: Gate.status,
    target: chatModel.chatLoaded,
})

export function ChatContainer() {
    useGate(Gate)

    const user = useUnit(chat.$userInfo)
    if (!user) {
        return <styled.ChatLoader />
    }

    return <ChatView />
}
